/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { NavLink } from "react-router-dom";

const LangleyCopyrightBar = () => {
    return (
        <div className='langley-copyright-bar'>
            <div className='copyright-bar-container'>
                <div className='copyright-text'>
                    Copyright © 2025 Township of Langley
                </div>
                <div className='copyright-bar-links'>
                    <NavLink to='https://www.tol.ca/en/connect/egovernment-privacy-policy.aspx'>
                        Privacy & Freedom of Information
                    </NavLink>
                    <NavLink to='https://www.tol.ca/en/connect/terms-of-use.aspx'>
                        Terms of Use
                    </NavLink>
                    <NavLink to='https://www.tol.ca/Common/Sitemap.aspx'>
                        Sitemap
                    </NavLink>
                    <NavLink to='https://www.tol.ca/en/index.aspx#'>
                        Website Feedback
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export { LangleyCopyrightBar };
